import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ProjectTemplate from './ProjectTemplate';
import BlankProject from "./projects/BlankProject";
import ExampleProj1Page from "./projects/ExampleProj1";
import ExampleProj2Page from "./projects/ExampleProj2";
import ExampleProj3Page from "./projects/ExampleProj3";
import ExampleProj4Page from "./projects/ExampleProj4";

import LinksPage from "./pages/LinksPage"; 
import NotFoundPage from "./pages/NotFoundPage";

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        
        <Route path="/project/blank" element={<BlankProject />} />
        <Route path="/project/exampleproj1" element={<ExampleProj1Page />} />
        <Route path="/project/exampleproj2" element={<ExampleProj2Page />} />
        <Route path="/project/exampleproj3" element={<ExampleProj3Page />} />
        <Route path="/project/exampleproj4" element={<ExampleProj4Page />} />

        <Route path="/project/:projectId" element={<ProjectTemplate />} />

        <Route path="/links/:slug" element={<LinksPage />} />

        {/* Catch-all route for 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
